import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import * as api from "../api";

function MesRFQ() {
  const [rfqs, setRfqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedRfq, setSelectedRfq] = useState(null);
  const [reponses, setReponses] = useState([]);
  const [loadingReponses, setLoadingReponses] = useState(false);

  useEffect(() => {
    loadRFQs();
  }, []);

  const loadRFQs = async () => {
    try {
      const res = await api.getMesRFQ();
      setRfqs(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const loadReponses = async (rfq) => {
    setSelectedRfq(rfq);
    setLoadingReponses(true);
    try {
      // Les réponses sont déjà incluses dans getMesRFQ (rfq.reponses)
      // On fait quand même un appel séparé pour avoir les données les plus récentes
      const res = await api.getReponsesRFQ(rfq.id);
      setReponses(Array.isArray(res.data) ? res.data : (rfq.reponses || []));
    } catch (err) {
      console.error(err);
      // Fallback : utiliser les réponses déjà chargées avec getMesRFQ
      setReponses(rfq.reponses || []);
    } finally {
      setLoadingReponses(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Navbar />
      <main style={{ flex: 1, background: "#f9fafb", padding: "32px 20px" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "28px" }}>
            <h1 style={{ margin: 0, fontSize: "24px", fontWeight: "800", color: "#1f2937" }}>Mes demandes de devis (RFQ)</h1>
            <Link to="/rfq" style={{ background: "#0d9488", color: "white", padding: "10px 20px", borderRadius: "10px", textDecoration: "none", fontWeight: "600", fontSize: "14px" }}>
              + Nouvelle demande
            </Link>
          </div>

          {loading ? (
            <p style={{ color: "#6b7280" }}>Chargement...</p>
          ) : rfqs.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px", background: "white", borderRadius: "16px" }}>
              <p style={{ color: "#9ca3af", fontSize: "16px" }}>Vous n'avez pas encore de demande de devis.</p>
              <Link to="/rfq" style={{ display: "inline-block", marginTop: "16px", background: "#0d9488", color: "white", padding: "12px 24px", borderRadius: "10px", textDecoration: "none", fontWeight: "600" }}>
                Faire une demande
              </Link>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {rfqs.map((rfq) => (
                <div key={rfq.id} style={{ background: "white", borderRadius: "12px", padding: "20px 24px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", border: selectedRfq?.id === rfq.id ? "2px solid #0d9488" : "2px solid transparent" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "12px" }}>
                    <div>
                      <h3 style={{ margin: "0 0 4px", color: "#1f2937", fontSize: "16px" }}>
                        {rfq.type_produit || rfq.besoin || "Demande #" + rfq.id}
                      </h3>
                      <p style={{ margin: 0, color: "#9ca3af", fontSize: "13px" }}>
                        {new Date(rfq.created_at).toLocaleDateString("fr-DZ")} — {rfq.annonce_nom ? `Annonce : ${rfq.annonce_nom}` : "Demande générale"}
                      </p>
                    </div>
                    <button
                      onClick={() => selectedRfq?.id === rfq.id ? setSelectedRfq(null) : loadReponses(rfq)}
                      style={{ background: "#f0fdfa", color: "#0d9488", border: "1px solid #99f6e4", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", fontWeight: "600", fontSize: "13px" }}
                    >
                      {selectedRfq?.id === rfq.id ? "Masquer" : "Voir les réponses"}
                    </button>
                  </div>

                  {rfq.details && (
                    <p style={{ margin: "12px 0 0", color: "#6b7280", fontSize: "14px", lineHeight: "1.5" }}>
                      {rfq.details.slice(0, 150)}{rfq.details.length > 150 ? "..." : ""}
                    </p>
                  )}

                  {/* Réponses */}
                  {selectedRfq?.id === rfq.id && (
                    <div style={{ marginTop: "20px", borderTop: "1px solid #f3f4f6", paddingTop: "16px" }}>
                      {loadingReponses ? (
                        <p style={{ color: "#9ca3af", fontSize: "14px" }}>Chargement des réponses...</p>
                      ) : reponses.length === 0 ? (
                        <p style={{ color: "#9ca3af", fontSize: "14px" }}>Aucune réponse pour l'instant. Les exposants ont été notifiés.</p>
                      ) : (
                        <div>
                          <p style={{ margin: "0 0 12px", fontWeight: "700", color: "#1f2937", fontSize: "14px" }}>
                            {reponses.length} réponse{reponses.length > 1 ? "s" : ""}
                          </p>
                          {reponses.map((rep) => (
                            <div key={rep.id} style={{ background: "#f9fafb", borderRadius: "10px", padding: "14px 16px", marginBottom: "10px", borderLeft: "3px solid #0d9488" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                <span style={{ fontWeight: "700", color: "#1f2937", fontSize: "14px" }}>
                                  {rep.auteur_nom}
                                  <span style={{ marginLeft: "8px", background: rep.auteur_role === "admin" ? "#fef3c7" : "#f0fdfa", color: rep.auteur_role === "admin" ? "#92400e" : "#0d9488", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "600" }}>
                                    {rep.auteur_role === "admin" ? "Admin" : "Exposant"}
                                  </span>
                                </span>
                                <span style={{ color: "#9ca3af", fontSize: "12px" }}>
                                  {new Date(rep.created_at).toLocaleDateString("fr-DZ")}
                                </span>
                              </div>
                              <p style={{ margin: 0, color: "#4b5563", fontSize: "14px", lineHeight: "1.6", whiteSpace: "pre-wrap" }}>{rep.contenu}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default MesRFQ;